import { getSportingChatURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { createQueryString } from 'utils/createQueryString';
import {
  SportingChat,
  SportingPagedResponse,
  SportingSecureParams,
  SportingServiceScope
} from 'services/sporting/types';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  page: number;
  size: number;
  destinactionType: SportingServiceScope;
};

export const getChats = async (
  params: SportingSecureParams<Payload>
): Promise<SportingPagedResponse<SportingChat>> => {
  const { payload } = params;

  const endpointURL = getSportingChatURL(
    `getChats?${createQueryString(payload)}`
  );

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, {
    headers
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }

  if (response.status === 200) {
    return response.json();
  }

  return {
    content: [],
    page: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
    last: true
  };
};
